// node_modules
import { ChangeEvent, forwardRef, KeyboardEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
// styles
import styles from "./findestTextBox.module.scss";

type TFindestRefTextBoxProps = {
    placeholder?: string,
    leftIcon?: IconDefinition,
    width?: number,
    isBorderless?: boolean,
    isTransparent?: boolean,
    isLargeFont?: boolean,
    hasNoPadding?: boolean,
    isHighlightGroupInputElement?: boolean,
    extraClassName?: string,
    extraClassNameInputElement?: string,
    margin?: string,
    onEnter?: (text: string) => void,
    onChange?: (text: string) => void,
    onClick?: () => void,
    onBlur?: () => void
}

export const FindestRefTextBox = forwardRef<HTMLInputElement, TFindestRefTextBoxProps>((props: TFindestRefTextBoxProps, ref) => {
    const handleOnKeyDown = (keyboardEvent: KeyboardEvent<HTMLInputElement>) => {
        if (props.onEnter && keyboardEvent.key === "Enter" && ref !== null) {
            props.onEnter(keyboardEvent.currentTarget.value);
        }
    };

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        if(props.onChange) {
            props.onChange(event.currentTarget.value);
        }
    }

    const getClassName = (): string => {
        let classNameList = [styles.findestTextBox];
        if(props.isBorderless) classNameList.push(styles.borderlessTextBox);    
        if(props.hasNoPadding) classNameList.push(styles.noPaddingTextBox);   
        if(props.isTransparent) classNameList.push(styles.transparent); 
        if(props.isLargeFont) classNameList.push(styles.largeFont); 
        return classNameList.join(" ");
    };

    const getClassNameInput = (): string => {
        let classNameList = [styles.textBox];
        if(props.isHighlightGroupInputElement) classNameList.push(styles.groupInputElement);
        return classNameList.join(" ");
    }

    return (
        <div className={[getClassName(), props.extraClassName ? props.extraClassName : ""].join(" ")} style={{ margin: props.margin }} onClick={props.onClick} >
            {props.leftIcon ? <FontAwesomeIcon className={styles.icon} icon={props.leftIcon} /> : <></>}
            <input ref={ref} style={{ width: props.width }} placeholder={props.placeholder} 
                className={[getClassNameInput(), props.extraClassNameInputElement ? props.extraClassNameInputElement : ""].join(" ")} onKeyDown={handleOnKeyDown} onChange={handleOnChange} onBlur={props.onBlur} />
        </div>
    );
});